import Button from "components/Button";
import ImageSlider from "components/ImageSlider";
import Link from "components/Link";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { config } from "config";
import { memo } from "react";
import theme from "theme";
import * as Styled from "../shared";
import { useForgotPassword } from "./useForgotPassword";

const ForgotPassword = memo(() => {
    const { email, isLoading, emailError, handleEmailChange, handleSubmit } =
        useForgotPassword();
    return (
        <Styled.Wrapper>
            <Styled.LeftWrapper>
                <Styled.Card>
                    <Text variant="heading5" align="center" fullWidth>
                        Forgot Password
                    </Text>
                    <Styled.Form onSubmit={handleSubmit}>
                        <TextInput
                            name="email"
                            type="email"
                            label="Email"
                            required
                            placeholder="user@email.com"
                            fullWidth
                            labelColor={theme.colors.text}
                            value={email}
                            errorMsg={emailError}
                            disabled={isLoading}
                            onChange={handleEmailChange}
                        />
                        <Button
                            type="submit"
                            variant="filled"
                            fullWidth
                            isLoading={isLoading}
                            textColor={theme.colors.white}
                            textVariant="button2"
                        >
                            Forgot Password
                        </Button>
                    </Styled.Form>
                    <Link
                        href="/login"
                        variant="label"
                        underline
                        color={theme.colors.text}
                    >
                        Log in
                    </Link>
                </Styled.Card>
            </Styled.LeftWrapper>
            <Styled.RightWrapper>
                <ImageSlider sliderImages={config.sliderImages} />
            </Styled.RightWrapper>
        </Styled.Wrapper>
    );
});

export default ForgotPassword;
